export default {
  CALCULATE_EMERGENCY_FUND_FIXED_TIME_CALCULATION_QUERY: Symbol.for('CALCULATE_EMERGENCY_FUND_FIXED_TIME_CALCULATION_QUERY'),
  EMERGENCY_FUND_FIXED_TIME_CALCULATION_REPOSITORY: Symbol.for('EMERGENCY_FUND_FIXED_TIME_CALCULATION_REPOSITORY'),
  CALCULATE_EMERGENCY_FUND_MONTHLY_PAYMENT_CALCULATION_QUERY: Symbol.for('CALCULATE_EMERGENCY_FUND_MONTHLY_PAYMENT_CALCULATION_QUERY'),
  EMERGENCY_FUND_MONTHLY_PAYMENT_CALCULATION_REPOSITORY: Symbol.for('EMERGENCY_FUND_MONTHLY_PAYMENT_CALCULATION_REPOSITORY'),
};
